import { UNSUPPORTED_ARGUMENT_ERROR } from './utils/errors'
import { createDivInBody } from './utils'
import ModalsContainer from './components/ModalsContainer.vue'

const PluginCore = function(Vue, options = {}) {
  const subscription = new Vue()

  const context = {
    root: null,
    componentName: options.componentName || 'Modal'
  }

  const showStaticModal = (name, params) => {
    subscription.$emit('toggle', name, true, params)
    const container = context.root.__modalContainer
    const modal = container.getByName(name)
    
    return {
      render: modal?.showPromise,
      result: modal?.resultPromise
    }  
  }

  const showDynamicModal = function(
    component,
    componentAttrs,
    modalProps = {},
    modalEvents
  ) {
    
    const container = context.root.__modalContainer
    const defaults = { ...options } || {}
    let rResolve, rReject, sResolve, sReject
    const resultPromise = new Promise((res, rej) =>{
      rResolve = res
      rReject = rej
    })
    const showPromise = new Promise((res, rej) =>{
      sResolve = res
      sReject = rej
    })

    container.add({
      component,
      componentAttrs: componentAttrs || {},
      modalAttrs: { ...defaults, ...modalProps } || {},
      modalListeners: modalEvents || {},
      resultPromise : {
        promise: resultPromise, resolve: rResolve, reject: rReject
      },
      showPromise: {
        promise: showPromise, resolve: sResolve, reject: sReject
      }  
    })

    return {
      render: showPromise,
      result: resultPromise
    }  

  }

  /**
   * Creates a container for modals in the root Vue component.
   *
   * @param {Vue} parent
   */
  const setDynamicModalContainer = parent => {
    context.root = parent

    const element = createDivInBody()

    new Vue({
      parent,
      render: h => h(ModalsContainer)
    }).$mount(element)
  }

  const show = (...args) => {
    const [modal] = args

    switch (typeof modal) {
      case 'string':
        return showStaticModal(...args)
        break

      case 'object':
      case 'function':
        return showDynamicModal(...args)
        break

      default:
        console.warn(UNSUPPORTED_ARGUMENT_ERROR, modal)
    }
  }

  const hide = (name, params) => {
    subscription.$emit('toggle', name, false, params)
  }

  const hideAll = () => {
    subscription.$emit('hide-all')
  }

  const toggle = (name, params) => {
    subscription.$emit('toggle', name, undefined, params)
  }

  return {
    context,
    subscription,
    show,
    hide,
    hideAll,
    toggle,
    setDynamicModalContainer
  }
}

export default PluginCore
